import { Component,
         Input,
         OnChanges,
         OnInit,
         SimpleChanges } from "@angular/core";

import { HighchartsOptions } from "../../components/highcharts/highcharts.interface";

@Component({
  standalone: false,
  selector: "app-pie-chart",
  templateUrl: "./pie-chart.component.html",
  styleUrls: ["./pie-chart.component.scss"]
})
export class PieChartComponent implements OnInit, OnChanges {
  @Input() total;
  @Input() series;
  @Input() title: string;
  @Input() legendY = -8;
  @Input() centralTitle = "Despachos";
  @Input() marginTop = -58;
  @Input() fontSize  = '11px'
  @Input() colorFondo: '#ECF4FC'
  @Input() size = '100%';
  @Input() titleWithMargin = false;

  optionsChart: any;

  constructor() {}

  ngOnInit(){
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['series'].currentValue){
      this.optionsChart = {
        chart: {
          spacingTop   : 0,
          spacingRight : 0,
          spacingBottom: 0,
          spacingLeft  : 0,
          marginTop    :this.marginTop,
          marginLeft   : 0,
          marginBottom : 0,
          marginRight  : 0,
          type: "pie",
          backgroundColor: this.colorFondo
          },

        title: {
          text: `${this.centralTitle} <br> ${this.total}`,
          verticalAlign: "middle",
          x: 0,
          y: -10,
          style: {
            fontWeight: 'bold',
            fontSize: "12px",
          },
        },

        plotOptions: {
          pie: {
            size: this.size,
            allowPointSelect: false,
            cursor: "pointer",

            dataLabels: {
              enabled: true,
              style:{
                fontSize  :'10.3px',
                fontWeight:'normal',
                color     :'black',
              },

              format  : "{point.percentage:.1f}%",
              distance: -30,
              filter: {
                property: "percentage",
                operator: ">",
                value: 4,
              },
            },
            showInLegend: true,
          },
        },

        legend : {
          align: "center",
          y: this.legendY,

          itemStyle   : {
            fontWeight: "normal",
            fontSize :this.fontSize,
          },

          labelFormatter: function () {
            const that: any = this;
            return `${that.name} ${(that.percentage*that.total/100).toFixed(0)}`;

          },
        },
        series: this.series,
      };
    }
  }

}
